import { usePage } from "@inertiajs/react"

import { CapabilityMark } from "@/components/ui/capability-mark"
import { Wordmark } from "@/components/ui/wordmark"
import { SpotlightLayout } from "@/layouts/spotlight-layout"

// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
type ThankYouProps = {
  booking: {
    id: number
    token: string
    program_type: string
    program_date: string
  }
  account: { id: number; name: string }
  submitted_at: string
}

// `checkin_form_submitted` is emitted server-side from
// Forms::CheckinsController#submit (BLU-10). This page is a bookmarkable GET on
// the booking token, so firing from its mount counted every refresh as another
// submission — the event belongs to the transition, not to the page that
// happens to follow it.
//
// The seam: the one place the focused form reconnects to the platform. A
// confirmed mark on paper, then the board with the name on it.
const ThankYou = () => {
  const { booking, account } = usePage<ThankYouProps>().props

  return (
    <SpotlightLayout>
      <section className="flex flex-col gap-10">
        <div className="flex flex-col items-center gap-6 py-6 text-center md:py-10">
          <CapabilityMark capability="do" size={72} />
          <div className="flex flex-col gap-3">
            <span className="eyebrow">check-in · submitted</span>
            <h1 className="text-display-sm text-primary">Check-in submitted</h1>
            <p className="text-tertiary max-w-[48ch] text-lg text-pretty">
              Thank you for completing the check-in form for your{" "}
              {booking.program_type} program with {account.name}. No further
              action is needed.
            </p>
          </div>
        </div>
        <div className="board -mx-4 flex items-end justify-between gap-6 rounded-xl px-6 py-6 sm:-mx-8 lg:-mx-10">
          <div className="flex flex-col gap-2">
            <Wordmark size={30} className="text-stone-50" />
            <span className="text-onprint-quiet text-3xs tracking-eyebrow font-mono leading-none font-medium uppercase">
              batyr · programs for schools
            </span>
          </div>
          <span className="notation text-onprint-quiet">
            {booking.program_date}
          </span>
        </div>
      </section>
    </SpotlightLayout>
  )
}

export default ThankYou
